import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './WerkorderDetailModal.css';

const WerkorderDetailModal = ({ werkorderId, onClose, onUpdate }) => {
  const [werkorder, setWerkorder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (werkorderId) {
      fetchWerkorder();
    }
  }, [werkorderId]);

  const fetchWerkorder = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/werkorders/${werkorderId}`);
      setWerkorder(response.data.werkorder);
    } catch (error) {
      console.error('Fout bij ophalen werkorder:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (newStatus) => {
    try {
      await api.put(`/werkorders/${werkorderId}`, { status: newStatus });
      fetchWerkorder();
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error('Fout bij bijwerken status:', error);
    }
  };

  if (!werkorderId) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content werkorder-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📋 Werkorder Details</h2>
          <button onClick={onClose} className="btn-close">✕</button>
        </div>

        {loading ? (
          <div className="loading">Laden...</div>
        ) : werkorder ? (
          <div className="modal-body">
            <div className="detail-section">
              <h3>#{werkorder.id} - {werkorder.titel}</h3>
              <div className="status-badges">
                <span className={`badge status-${werkorder.status}`}>{werkorder.status}</span>
                <span className={`badge prioriteit-${werkorder.prioriteit}`}>
                  {werkorder.prioriteit === 'hoog' ? '🔴' : werkorder.prioriteit === 'normaal' ? '🟡' : '🟢'} 
                  {werkorder.prioriteit}
                </span>
              </div>
            </div>

            <div className="detail-section">
              <label>Beschrijving:</label>
              <p>{werkorder.beschrijving || 'Geen beschrijving'}</p>
            </div>

            <div className="detail-grid">
              <div className="detail-item">
                <label>📅 Gepland:</label>
                <p>{werkorder.geplande_datum ? new Date(werkorder.geplande_datum).toLocaleDateString('nl-NL') : 'Niet gepland'}</p>
              </div>

              <div className="detail-item">
                <label>👤 Toegewezen aan:</label>
                <p>{werkorder.toegewezen_naam || 'Niet toegewezen'}</p>
              </div>

              <div className="detail-item">
                <label>🏢 Afdeling:</label>
                <p>{werkorder.afdeling_naam}</p>
              </div>

              <div className="detail-item">
                <label>📍 Locatie:</label>
                <p>{werkorder.locatie_adres || 'Geen locatie'}</p>
              </div>

              {werkorder.afgerond_op && (
                <div className="detail-item">
                  <label>✅ Afgerond op:</label>
                  <p>{new Date(werkorder.afgerond_op).toLocaleString('nl-NL')}</p>
                </div>
              )}
            </div>

            {werkorder.status !== 'afgerond' && (
              <div className="detail-section">
                <label>Status wijzigen:</label>
                <div className="status-buttons">
                  <button 
                    onClick={() => handleStatusChange('in_behandeling')}
                    className="btn-secondary"
                    disabled={werkorder.status === 'in_behandeling'}
                  >
                    ⏳ In behandeling
                  </button>
                  <button 
                    onClick={() => handleStatusChange('afgerond')}
                    className="btn-success"
                  >
                    ✅ Afronden
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="error">Werkorder niet gevonden</div>
        )}

        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">Sluiten</button>
        </div>
      </div>
    </div>
  );
};

export default WerkorderDetailModal;
